const RecapGPTSection = ({ title, icon, onEdit, children }) => (
    <div className={'row justify-content-center'}>
        <div className={'col-12 col-lg-8 my-2'}>
            <div className={'p-3 bg-white rounded border'}>
                <div className={'row'}>
                    <div className="col-2 col-lg-1">
                        {icon && <img src={icon} alt={title} width={40} loading="lazy" />}
                    </div>
                    <div className="col-10 col-lg-11 text-start">
                        <p className={'f-14 text-primary fw-bold'}>
                            {title}
                            {onEdit && (
                                <span
                                    className={'text-secondary f-12 float-end cursor-pointer underline-link'}
                                    onClick={onEdit}
                                >
                                    modifier
                                </span>
                            )}
                        </p>
                        <div className={'f-13'}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default RecapGPTSection;
